/* eslint-disable @typescript-eslint/camelcase */
// @file Profile Vuex Store.
import { fetchJson } from '@padlet/fetch'
import window from 'bits/global'
import Vue from 'vue'
import Vuex, { Plugin, StoreOptions } from 'vuex'
import browser from 'vuexstore/modules/browser'
import electronApp, { ElectronAppState } from 'vuexstore/modules/electron_app'
import experiments from 'vuexstore/modules/experiments'
import plans from 'vuexstore/modules/plans'
import electronBridgeListener from 'vuexstore/plugins/electron_bridge_listener'
import logger from 'vuexstore/plugins/logger'
import confirmationDialog from 'vuexstore/modules/global_confirmation_dialog'

type UserProfileState = {
  // Modules
  electronApp?: ElectronAppState
}

Vue.use(Vuex)

const plugins: Plugin<UserProfileState>[] = [electronBridgeListener<UserProfileState>('user_profile')]

if (
  process.env.NODE_ENV === 'development' ||
  (process.env.NODE_ENV === 'test' && ['true', 'yes', '1'].includes(process.env.LOG_VUEX || ''))
) {
  plugins.push(logger)
}

const store: StoreOptions<UserProfileState> = {
  plugins,
  modules: {
    electronApp,
    experiments,
    browser,
    plans,
    confirmationDialog,
  },
  actions: {
    async initializeState({ dispatch }): Promise<void> {
      const { experiment } = await fetchJson('/dashboard.json')
      dispatch('plans/fetchPlans')
      dispatch('plans/fetchAdvertisedQuotas')
      dispatch('experiments/initializeState', experiment)
    },
  },
}
/* eslint-enable @typescript-eslint/explicit-function-return-type */
if (!window.ww) {
  window.ww = {}
}

const xstore = new Vuex.Store<UserProfileState>(store)
window.ww.xstore = xstore

export default xstore
